<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-24 11:46:03
 * @LastEditTime: 2019-10-10 15:40:08
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="addGuide">
    <el-form ref="form" :rules="rules" :model="form" label-width="110px">
      <el-form-item label="姓名:" prop="dealer_sn">
        <el-input v-model="form.dealer_sn "></el-input>
      </el-form-item>
      <el-form-item label="手机号(账号):" prop="dealer_name">
        <el-input v-model="form.dealer_name "></el-input>
      </el-form-item>
      <el-form-item label="登录密码:" prop="dealer_name">
        <el-input v-model="form.dealer_name " type="password"></el-input>
      </el-form-item>
      <el-form-item label="所属身份分组:" prop="dealer_name">
        <el-select
          v-model="form.area"
          placeholder="区"
          clearable
          style="margin-right:10px"
          @change="$forceUpdate()"
        >
          <el-option v-for=" i in areas" :key="i.id" :label="i.region_name" :value="i.region_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属门店:">
        <el-col :span="5">
          <el-input v-model="form.to_sn" clearable></el-input>
        </el-col>
        <el-col :span="4" style="margin-left: 10px;">
          <el-button type="primary" @click="selectStoreDialog=!selectStoreDialog">选择所在门店</el-button>
          <el-button @click="form.to_sn=''">清除</el-button>
        </el-col>
      </el-form-item>
      <el-form-item label="所在地址:" prop="address">
        <el-select
          v-model="form.country"
          placeholder="国"
          clearable
          style="margin-right:10px"
          @change="getprovinces()"
        >
          <el-option v-for=" i in countrys" :key="i.id" :label="i.region_name" :value="i.region_id"></el-option>
        </el-select>
        <el-select
          v-model="form.province"
          placeholder="省"
          clearable
          style="margin-right:10px"
          @change="getcity()"
        >
          <el-option
            v-for=" i in provinces"
            :key="i.id"
            :label="i.region_name"
            :value="i.region_id"
          ></el-option>
        </el-select>
        <el-select
          v-model="form.city"
          placeholder="市"
          clearable
          style="margin-right:10px"
          @change="getArea()"
        >
          <el-option v-for=" i in citys" :key="i.id" :label="i.region_name" :value="i.region_id"></el-option>
        </el-select>
        <el-select
          v-model="form.area"
          placeholder="区"
          clearable
          style="margin-right:10px"
          @change="$forceUpdate()"
        >
          <el-option v-for=" i in areas" :key="i.id" :label="i.region_name" :value="i.region_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label=" 1" class="label">
        <el-input type="textarea" v-model="form.detail" placeholder="请输入内容"></el-input>
      </el-form-item>
      <el-form-item label="微信号:" prop="person">
        <el-input v-model="form.person" placeholder="请输入经销商负责人"></el-input>
      </el-form-item>
      <el-form-item label="上传图片:" prop="mobile">
          <el-upload
            action="https://jsonplaceholder.typicode.com/posts/"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :limit='3'
            >
            <i class="el-icon-plus"></i>
          </el-upload>
          <span>
            图片宽度要求1:1比例，建议尺寸为640px*640px以上；最多上传3张图片，您可以拖拽图片调整图片顺序。
          </span>
        <!-- <el-input v-model="form.mobile " placeholder="请输入手机号"></el-input>
        <div style></div> -->
      </el-form-item>
      <el-form-item label="备注:" prop="password" v-if="!$route.query.edit">
        <el-input type="textarea" v-model="form.detail" placeholder="请输入内容"></el-input>
      </el-form-item>
    </el-form>
    <div class="btns">
      <el-button type="primary" style="margin:0 auto;" @click="save">保存</el-button>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
import { setTimeout } from "timers";
import { fips } from "crypto";
export default {
  name: "addStore",
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      fileList:[],
      fileArr:[],
      imageUrl: false,
      getGps: false,
      activeNames: "1",
      form: {
        detail: "",
        gps: "",
        person: "",
        password: "",
        from_level_id: "",
        price: "",
        imageUrl: []
      },
      areaText: [],
      delete: [],
      is_delete_img: "0",
      delete_img: [],
      rules: {
        dealer_sn: [
          { required: true, message: "请输入经销商编号", trigger: "blur" }
        ],
        gps: [{ required: true, message: "请选择gps", trigger: "change" }],
        img_url: [
          { required: true, message: "请选择经销商图片", trigger: "blur" }
        ],
        person: [
          { required: true, message: "请输入经销商负责人", trigger: "blur" }
        ],
        storename: [
          { required: true, message: "请填写活动形式", trigger: "blur" }
        ],
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        dealer_name: [
          { required: true, message: "请输入经销商名称", trigger: "blur" }
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        level_id: [
          { required: true, message: "请选择经销商级别", trigger: "change" }
        ]
      },
      dealerLevel: [],
      countrys: [],
      provinces: [],
      citys: [],
      areas: [],
      region: [],
      regionsTemp: [], //存放 上级已选区域
      dealer_area: [] //存放 所属区域
    };
  },
  methods: {
    handleSuccess(response, file, fileList) {
        // this.form.name.push(file.name)
        // if(this.form.name == ''){
        //     this.form.name += file.name;
        // }else{
        //     this.form.name = this.form.name + "," + file.name;
        // }
        console.log('jjjj',response)
        // this.fileArr.push(response.data[0]);
    },
    handleRemove(file, fileList) {

      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    init() {
      this.getGps = true;
      setTimeout(() => {
        this.getGps = false;
      }, 200);
    },
    isEdit() {
      if (this.$route.query.edit) {
        this.$get("logistics_2", "/vstore/dealer_pc/dealerdetail", {
          id: this.$route.query.edit
        }).then(res => {
          this.form = res.data;
          this.getprovinces("edit");
          this.getcity("edit");
          this.getArea("edit");
          this.form.region.forEach(element => {
            this.areaText.push(element.address);
            this.region.push(element.id);
          });
        });
      }
    },
           // 获取四级联动
                getcountry(temp){
                  if(temp){
                 this.$get('logistics_2','/vstore/dealer_pc/area',{
                         type:1,
                     }).then(res=>{
                        this.countrys=res.data
                    
                        }).catch(error=>{
                        }) 
                  }else{
                     this.$get('logistics_2','/vstore/dealer_pc/area',{
                         type:1,
                     }).then(res=>{
                        this.countrys=res.data
                           this.citys=[]
                        this.areas=[]
                        this.provinces=[]
                        }).catch(error=>{
                        }) 
                  }
                         
                } ,
    getprovinces(temp) {
      if (temp) {
        this.$get("logistics_2", "/vstore/dealer_pc/area", {
          type: 2,
          parent_id: this.form.country
        })
          .then(res => {
            this.provinces = res.data;
          })
          .catch(error => {});
      } else {
        this.citys = [];
        this.provinces = [];
        this.areas = [];
        this.form.province = "";
        this.form.city = "";
        this.form.area = "";

        this.$get("logistics_2", "/vstore/dealer_pc/area", {
          type: 2,
          parent_id: this.form.country
        })
          .then(res => {
            this.provinces = res.data;
          })
          .catch(error => {});
      }
    },
    getcity(temp) {
      if (temp) {
        this.$forceUpdate();

        this.$get("logistics_2", "/vstore/dealer_pc/area", {
          type: 2,
          parent_id: this.form.province
        })
          .then(res => {
            this.citys = res.data;
          })
          .catch(error => {});
      } else {
        this.$forceUpdate();
        this.citys = [];
        this.areas = [];
        this.form.city = "";
        this.form.area = "";
        this.$get("logistics_2", "/vstore/dealer_pc/area", {
          type: 2,
          parent_id: this.form.province
        })
          .then(res => {
            this.citys = res.data;
          })
          .catch(error => {});
      }
    },
    getArea(temp) {
      if (temp) {
        this.$forceUpdate();

        this.$get("logistics_2", "/vstore/dealer_pc/area", {
          type: 2,
          parent_id: this.form.city
        })
          .then(res => {
            this.areas = res.data;
          })
          .catch(error => {});
      } else {
        this.$forceUpdate();
        this.areas = [];
        this.form.area = "";
        this.$get("logistics_2", "/vstore/dealer_pc/area", {
          type: 2,
          parent_id: this.form.city
        })
          .then(res => {
            this.areas = res.data;
          })
          .catch(error => {});
      }
    },
    save() {
      console.log('文件',
      )
      console.log('上传图片',this.fileArr)
      // if (this.form.country == "") {
      //   this.$message({
      //     type: "error",
      //     message: "请选择国家"
      //   });
      //   return;
      // }

      // var ids = [
      //   this.form.region_country ? this.form.region_country : 0,
      //   this.form.region_province ? this.form.region_province : 0,
      //   this.form.region_city ? this.form.region_city : 0,
      //   this.form.region_area ? this.form.region_area : 0
      // ];
      // this.$refs["form"].validate(valid => {
      //   if (valid) {
      //     this.form.parent_dealer_id = this.form.level_id;
      //     this.form.from_level_id = this.form.level_id;
      //     if (this.$route.query.edit) {
      //       this.$post("logistics_2", "vstore/dealer_pc/editdealer", {
      //         ...this.form,
      //         set_password: "0",
      //         region: this.region
      //       }).then(res => {
      //         if (res.code == 0) {
      //           this.$message({
      //             type: "error",
      //             message: res.msg
      //           });
      //         } else {
      //           this.$message({
      //             type: "success",
      //             message: "成功"
      //           });
      //           this.$router.push({
      //             name: "next_leve"
      //           });
      //         }
      //       });
      //     } else {
      //       this.$post("logistics_2", "vstore/dealer_pc/adddealer", {
      //         ...this.form,
      //         region: this.region
      //       }).then(res => {
      //         if (res.code == 0) {
      //           this.$message({
      //             type: "error",
      //             message: res.msg
      //           });
      //         } else {
      //           this.$message({
      //             type: "success",
      //             message: "成功"
      //           });
      //           this.$router.push({
      //             name: "next_leve"
      //           });
      //         }
      //       });
      //     }
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
    close() {
      this.getGps = false;
    },
    GPS() {
      this.getGps = !this.getGps;
    },
    confirm(value) {
      this.getGps = false;
      this.form.gps = value.point.lng + "," + value.point.lat;
    }
  },
  created() {
    // this.getRegionsList();

    this.getcountry();

    this.isEdit();
  },
  components: {
  }
};
</script>
<style lang="scss" scoped>
.addGuide {
  background-color: #fff;

  padding: 15px;
  /deep/.el-collapse-item__header {
    padding: 0 10px;
    border-bottom: 1px solid #eee;
    margin-bottom: 10px;
    // background-color: rgb(242, 242, 242);
  }
  /deep/.el-collapse-item__content {
    padding: 30px 100px;
  }
  /deep/.el-input {
    width: auto;
    width: 250px;
    margin-right: 10px;
  }
  /deep/.el-form-item__label {
    // width: 95px !important;
  }
  /deep/.el-textarea {
    width: 500px;
    height: 200px;
    .el-textarea__inner {
      height: 100%;
    }
  }
  .label {
    /deep/.el-form-item__label {
      //   width: 95px !important;
      color: #fff;
    }
  }
  .avatar-uploader {
    display: inline-block;
    border: 1px dashed #eee;
  }
  .avatar-uploader .el-upload {
    display: inline-block;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .tips {
    display: inline-block;
    width: 250px;
    color: #333;
    vertical-align: middle;
    margin-left: 10px;
  }
}
.avatar-uploader {
  float: left;
  margin-right: 10px;
}
.imgList {
  float: left;
  width: 180px;
  height: 180px;
  margin-right: 10px;
  position: relative;
  img {
    width: 100%;
  }
  span {
    display: inline-block;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    bottom: 0;
    right: 0;
    left: 0;
    position: absolute;
    padding: 15px 0;
    display: none;
    i {
      float: right;
      margin-right: 20px;
      font-size: 15px;
    }
  }
}

.imgList:hover span {
  display: block;
}
.btns {
  text-align: center;
  padding-top: 20px;
}
/deep/.el-collapse {
  border-bottom: none;
}
.areaBox {
  width: 178px;
  border: 1px solid #eee;
  height: 178px;
  overflow-y: scroll;
  ul {
    width: 100%;
    li {
      height: 40px;
      padding: 0 10px;
      span:first-child {
        float: left;
      }
      span:last-child {
        float: right;
        cursor: pointer;
      }
    }
    li:hover {
      background-color: #eee;
    }
  }
}
</style>


